import { type GA4 } from "./interfaces";

export async function sendBeginCheckoutDatalayerEvent(
  payload: GA4.BeginCheckoutPayload,
) {
  window.gtag({ ecommerce: null });

  window.gtag({
    event: "begin_checkout",
    ecommerce: payload,
  });
}
